__turbopack_context__.v({
  "active": "SGAIqW_active",
  "backIcon": "SGAIqW_backIcon",
  "backWrapper": "SGAIqW_backWrapper",
  "closeIcon": "SGAIqW_closeIcon",
  "header": "SGAIqW_header",
  "notFound": "SGAIqW_notFound",
  "option": "SGAIqW_option",
  "options": "SGAIqW_options",
  "root": "SGAIqW_root",
  "searchIcon": "SGAIqW_searchIcon",
  "searchInput": "SGAIqW_searchInput",
  "searchWrapper": "SGAIqW_searchWrapper",
});
